import { LlmInfoShort } from "./LlmInfoShort";

export class LlmInfo extends LlmInfoShort {
  public contextWindowTokens: number;
  public maxOutputTokens: number;
  public defaultTemperature: number;
  public fallbackLlmNames: string[];
  public maxThinkingTokens?: number;
  public enableThinking?: boolean;
  public longContextLlmName?: string;

  constructor(data: any) {
    super(data);
    this.contextWindowTokens = data.contextWindowTokens;
    this.maxOutputTokens = data.maxOutputTokens;
    this.defaultTemperature = data.defaultTemperature;
    this.fallbackLlmNames = data.fallbackLlmNames || [];
    this.maxThinkingTokens = data.maxThinkingTokens;
    this.enableThinking = data.enableThinking;
    this.longContextLlmName = data.longContextLlmName;
  }
}
